module.exports = __webpack_public_path__ + "./kit/docs/img/android.48d4f4fbcd39dde30af383eb2e3294b7.svg";